import { useForumType } from '@/components/hooks/useForumType';
import React from 'react';
import { commentModerationWarningCommentIdSetting } from '@/lib/instanceSettings';
import { useQuery } from "@/lib/crud/useQuery";
import { gql } from "@/lib/generated/gql-codegen";
import ContentStyles from "../common/ContentStyles";
import { ContentItemBody } from "../contents/ContentItemBody";
import Loading from "../vulcan-core/Loading";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const CommentsListQuery = gql(`
  query NewCommentModerationWarning($documentId: String) {
    comment(input: { selector: { documentId: $documentId } }) {
      result {
        ...CommentsList
      }
    }
  }
`);

const styles = defineStyles('NewCommentModerationWarning', (theme: ThemeType) => ({
  root: {
    borderBottom: theme.palette.border.commentBorder,
    padding: 12,
    paddingRight: 28
  }
}));

export const NewCommentModerationWarning = () => {
  const { forumType } = useForumType();
  const classes = useStyles(styles);
  const documentId = commentModerationWarningCommentIdSetting.get(forumType)
  
  const { loading, data } = useQuery(CommentsListQuery, {
    variables: { documentId: documentId },
    skip: !documentId,
  });
  const document = data?.comment?.result;

  const { html = "" } = document?.contents || {}

  return <div className={classes.root}>
    <ContentStyles contentType="comment">
      {loading && <Loading/>}
      {html &&  <ContentItemBody dangerouslySetInnerHTML={{__html: html }} />}
      {!html && !loading && <div><em>A moderator will need to review your account before your comments will appear publicly.</em></div>}
    </ContentStyles>
  </div>;
}

export default NewCommentModerationWarning;



